import './ServicesSection.css';
import ServiceDescriptionPanel from '../../components/ServiceDescriptionPanel';
import Translator from '../../translates/Translator';
import imageCafm from '../../assets/img/services-cafm.jpg';
import imageCafmnew from '../../assets/img/services-cafm-new.jpg';
import imageFm from '../../assets/img/services-fm.jpg';
import imagePasportizace from '../../assets/img/services-pasp.jpg';
import imageBim from '../../assets/img/services-bim.jpg';
import hexes from '../../assets/img/hexes';

const ServicesSection = (props) => {
    const t = Translator();

    return (
        <div id="servicesSection" className='services'>
            <img src={hexes.h6_80} className="hex6 o-50" alt='' />
            <img src={hexes.h6_80} className="hex6 o-50" alt='' />
            <h2 className='text-main'>{t("services-section-title")}</h2>
            <ServiceDescriptionPanel
                title={t("service1-title")}
                subtitle={t('service1-subtitle')}
                imgOnLeft={false}
                img={<img src={imageCafmnew} alt="archibus" className="br-4" loading='lazy' />}
                path={"/services/archibus"}
            >
                <p>{t("service1-desc")}</p>
            </ServiceDescriptionPanel>
            <ServiceDescriptionPanel
                title={t("service2-title")}
                subtitle={t('service2-subtitle')}
                imgOnLeft={true}
                img={<img src={imageFm} alt="fm" className="br-4" loading='lazy' />}
                path={"/services/archibus"}
            >
                <p>{t("service2-desc")}</p>
            </ServiceDescriptionPanel>
            <ServiceDescriptionPanel
                title={t("service3-title")}
                subtitle={t('service3-subtitle')}
                imgOnLeft={false}
                img={<img src={imagePasportizace} alt="pasportizace" className="br-4" loading='lazy' />}
                path={""}
            >
                <p className=''>{t('service3-desc01')}</p>
                <p className=''>{t('service3-desc02')}</p>
            </ServiceDescriptionPanel>
            <ServiceDescriptionPanel
                title={t("service4-title")}
                subtitle={t('service4-subtitle')}
                imgOnLeft={true}
                img={<img src={imageBim} alt="bim" className="br-4" loading='lazy' />}
                path={"/services/bim"}
            >
                <p>{t("service4-desc")}</p>
            </ServiceDescriptionPanel>
        </div>
    );
}

export default ServicesSection;